module.exports = __webpack_public_path__ + "static/media/mongodb-logo.4dae2a92.png";